import BlacklightRangeLimit from "blacklight-range-limit";

// The verification page has no .facet-values element for the plugin to extract.
export default class RangeLimit extends BlacklightRangeLimit {
  extractBucketData(values = this.distributionElement.querySelector(".facet-values")) {
    if (values) return super.extractBucketData(values);
    this.rangeBuckets = [];
    return values;
  }

  placeFacetValuesListElement(values) {
    if (values) return super.placeFacetValuesListElement(values);

    const notice = document.createElement("p");
    notice.setAttribute("role", "status");
    notice.append("Year suggestions couldn't be loaded. ");
    const refresh = document.createElement("a");
    refresh.href = window.location.href;
    refresh.textContent = "Refresh the page to try again.";
    // Force a full request so the search page can display the challenge.
    refresh.setAttribute("data-turbolinks", "false");
    notice.append(refresh);
    this.distributionElement.replaceChildren(notice);
  }
}
